import React, { ReactNode } from 'react';

import { CartLayout } from '@sharedComponents/Layout';
import { IBasicTestProps } from '@styles/model';
import { ReactFCV } from '@types';

import { ButtonColumn, PriceColumn } from './componentHelpers';

interface IBenefitItemProps extends IBasicTestProps {
  title: string | JSX.Element | ReactNode;
  info?: string | JSX.Element | ReactNode;
  onClick?: () => void;
  icon?: JSX.Element;
  value?: number;
  buttonContent?: string | JSX.Element;
  buttonContextHelp?: string;
  dataTestId?: string;
  benefitDisabled?: boolean;
  isDualPriceLayout: boolean;
  isVoucher?: boolean;
}

export const BenefitItem: ReactFCV<IBenefitItemProps> = ({
  icon,
  value,
  buttonContextHelp,
  onClick,
  buttonContent,
  title,
  info,
  dataTestId,
  benefitDisabled = false,
  isDualPriceLayout,
  isVoucher = false,
}) => {
  return (
    <CartLayout
      className={dataTestId}
      serviceActive={true}
      serviceDisabled={benefitDisabled}
      iconColumn={icon ? () => icon : null}
      bodyColumn={() => title}
      priceColumn={PriceColumn(value, isDualPriceLayout, isVoucher)}
      infoColumn={info ? () => info : null}
      buttonColumn={ButtonColumn(buttonContent, buttonContextHelp, onClick)}
    />
  );
};
